export enum CheckoutPlacementEnum {
  RighSidebar = 'rightSidebar',
  LeftSidebar = 'leftSidebar',
  AsModal = 'asModal',
  top = 'top'
}
